"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SiteMap = void 0;
var _models = require("../models");
const SiteMap = exports.SiteMap = {
    Category: {
        path: '/:categoryName',
        title: 'Category',
        to: (categoryName)=>"/".concat(categoryName)
    },
    Home: {
        path: '/',
        title: _models.TranslationKey.supportCenter,
        to: ()=>'/'
    },
    Search: {
        path: '/search',
        title: _models.TranslationKey.search,
        to: (query)=>"/search?query=".concat(query)
    }
};
